import Vue from 'vue';
import VueRouter from 'vue-router';
import index from '@/views/index.vue';
import TranslateForm from '@/views/TranslateForm.vue';
import privacy from '@/views/privacy.vue';
import terms from '@/views/terms.vue';
Vue.use(VueRouter);

const routes = [
  { path: '/index', component: index },
  { path: '/TranslateForm', component: TranslateForm ,name:'TranslateForm'},
    { path: '/privacy', component: privacy },
    { path: '/terms', component:terms },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js